module.exports = __webpack_public_path__ + "static/media/aler.dd6b1bff.png";